import React from 'react';
import "./services.css";
import { useTranslation } from 'react-i18next';

const Services = () => {
  const { t } = useTranslation();

  const servicesData = [
    {
      id: 1,
      icon: "icon-lock",
      title: t('services.cybersecurity.title'),
      description: t('services.cybersecurity.description'),
    },
    {
      id: 2,
      icon: "icon-settings",
      title: t('automation') ? `${t('automation')} & DevOps` : "Automatisering & DevOps",
      description: "Automatisering van netwerkinfrastructuur, CI/CD pipelines, containerisatie en cloudbeheer.",
    },
    {
      id: 3,
      icon: "icon-globe",
      title: t('services.network_engineering.title'),
      description: t('services.network_engineering.description'),
    },
  ];

  return (
    <section className="services container section" id="services">
      <h2 className="section__title">{t('services.title')}</h2>

      <div className="services__container grid">
        {servicesData.map(({ id, icon, title, description }) => (
          <div className="services__card" key={id}>
            <i className={icon}></i>
            <h3 className="services__title">{title}</h3>
            <p className="services__description">{description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;